import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, AppsSiteManagement, Project, Site } from '../../models';
import { SiteColumnSettings } from '../../models/site-column-settings';
import { GridColumnProperties } from '../logic-services/models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
/* istanbul ignore file */
export class SitesDataService extends HttpBaseService {
    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    activateAllSites(currentApp: App): Observable<Site[]> {
        const url = `${this.route}${currentApp.id}/sites/activate-all-sites`;
        return this.httpPatch(url, currentApp);
    }

    updateSiteActive(appId: string, site: Site, newStatus: boolean): Observable<Site> {
        const url = `${this.route}${appId}/sites/${site.id}/active`;
        return this.httpPut(url, newStatus);
    }

    updateSiteAutoRenew(appId: string, site: Site, newStatus: boolean): Observable<Site> {
        const url = `${this.route}${appId}/sites/${site.id}/auto-renew`;
        return this.httpPut(url, newStatus);
    }

    getSingleSite(app: App, siteId: string): Observable<Site> {
        const url = `${this.route}${app.id}/sites/${siteId}`;
        return this.httpGet(url);
    }

    getVisibleSites(app: App): Observable<Site[]> {
        const url = `${this.route}${app.id}/visible-sites`;
        return this.httpGet(url);
    }

    getSitesByApp(app: App): Observable<Site[]> {
        const url = `${this.route}${app.id}/sites`;
        return this.httpGet(url);
    }

    createSite(app: App, project: Project, site: Site): Observable<Site> {
        const url = `${this.route}${app.id}/projects/${project.id}`;
        return this.httpPost(url, site);
    }

    createSiteAndApplyTemplate(app: App, project: Project, updatedSite: Site, selectedSiteTemplateId: string): Observable<Site> {
        const url = `${this.route}${app.id}/projects/${project.id}/sites/from-template/${selectedSiteTemplateId}`;
        return this.httpPost(url, updatedSite);
    }

    updateSite(app: App, site: Site): Observable<Site> {
        const url = `${this.route}${app.id}/sites/${site.id}`;
        return this.httpPut(url, site);
    }

    updateSiteAndApplyTemplate(app: App, project: Project, site: Site, selectedSiteTemplateId: string): Observable<Site> {
        const url = `${this.route}${app.id}/projects/${project.id}/sites/${site.id}/from-template/${selectedSiteTemplateId}`;
        return this.httpPut(url, site);
    }

    deleteSite(app: App, site: Site): Observable<null> {
        const url = `${this.route}${app.id}/sites/${site.id}`;
        return this.httpDelete(url);
    }

    getLatLongByAddress(site: Site): Observable<any> {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(`${site.address},${site.city},${site.state},${site.zipCode}`)}&key=AIzaSyAwJWdBYQ_KHDMF1C_hmyVR5MBLbMRQMs4`;
        return this.httpGet(url);
    }

    updateSiteGridColumnWidth(currentApp: App, currentProject: Project, currentSite: Site, gridId: string, columnChanged: GridColumnProperties): Observable<SiteColumnSettings[]> {
        const url = `${this.route}${currentApp.id}/sites/${currentSite.id}/projects/${currentProject.id}/grids/${gridId}/width`;
        return this.httpPut(url, columnChanged);
    }

    updateSiteGridColumnAggregator(currentApp: App, currentProject: Project, currentSite: Site, gridId: string, columnChanged: GridColumnProperties): Observable<SiteColumnSettings[]> {
        const url = `${this.route}${currentApp.id}/sites/${currentSite.id}/projects/${currentProject.id}/grids/${gridId}/aggregator`;
        return this.httpPut(url, columnChanged);
    }

    getSitesCountByAppId(appId: string, activeStatus = true): Observable<number> {
        const url = `${this.route}${appId}/sites/count?active=${activeStatus}`;
        return this.httpGet(url);
    }

    getSiteRenewalSummaryAllApps(): Observable<AppsSiteManagement> {
        const url = `${this.route}renewal-summary`;
        return this.httpGet(url);
    }
}
